import type { Jet } from '~/jet';
import type { LoggerFactory } from '@amp/web-apps-logger';
import type { PausePlaybackAction } from '~/actions/playback-actions';
// Safe because this file is only imported from ./browser.ts
import type { Playback } from '~/utils/playback/browser-only';

export type Dependencies = {
    jet: Jet;
    logger: LoggerFactory;
    playback: Playback;
};

export function registerHandler(dependencies: Dependencies) {
    const { jet, logger, playback } = dependencies;

    const log = logger.loggerFor('jet/action-handlers/pause-action');

    jet.onAction('pausePlaybackAction', async (action: PausePlaybackAction) => {
        log.info('received PausePlaybackAction:', action);
        try {
            await playback.pause();
            return 'performed';
        } catch (e) {
            // TODO: rdar://73165545 (Error Handling Across App)
            throw new Error(
                'an error occurred while handling PausePlaybackAction',
                e,
            );
        }
    });
}
